export default {"src":"/_next/static/media/prestashop.03494428.svg","height":100,"width":565,"blurWidth":0,"blurHeight":0};